import React from 'react'
import styled from 'styled-components/macro'
import { HexArrowButton, HexArrowButtonDisabled, HexArrowButtonDisabledFilled } from 'assets/svg'

interface IProps {
  onClick: (e: any) => void
  isActive: boolean
  startColor: string
  endColor: string
  arrowColor: string
  isOthersScreen?: boolean
  disabledBtnFilled?: boolean
  isReversed?: boolean
}

export const HexagonButton: React.FC<IProps> = ({
  onClick,
  isActive,
  startColor,
  endColor,
  arrowColor,
  disabledBtnFilled = false,
  isReversed = false,
}) => {
  return (
    <>
      {isActive ? (
        <ActiveButton onClick={onClick}>
          <HexArrowButton
            startColor={startColor}
            endColor={endColor}
            arrowColor={arrowColor}
            isReversed={isReversed}
          />
        </ActiveButton>
      ) : !isActive && !disabledBtnFilled ? (
        <HexArrowButtonDisabled />
      ) : (
        <HexArrowButtonDisabledFilled />
      )}
    </>
  )
}

const ActiveButton = styled.div`
  cursor: pointer;
  line-height: 0;
`
